var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUbrCellphone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 24,
    viewBox: "0 0 16 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1055 0.800293H3.35547C1.63672 0.800293 0.230469 2.20654 0.230469 3.92529V20.1753C0.230469 21.894 1.63672 23.3003 3.35547 23.3003H12.1055C13.8242 23.3003 15.2305 21.894 15.2305 20.1753V3.92529C15.2305 2.20654 13.8242 0.800293 12.1055 0.800293ZM13.9805 20.1753C13.9805 21.2065 13.1367 22.0503 12.1055 22.0503H3.35547C2.32422 22.0503 1.48047 21.2065 1.48047 20.1753V3.92529C1.48047 2.89404 2.32422 2.05029 3.35547 2.05029H12.1055C13.1367 2.05029 13.9805 2.89404 13.9805 3.92529V20.1753Z",
    fill: "#166649"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2305 3.26904H5.23047V4.51904H10.2305V3.26904Z",
    fill: "#166649"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.98047 19.5503H6.48047V20.8003H8.98047V19.5503Z",
    fill: "#166649"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUbrCellphone);
export default __webpack_public_path__ + "static/media/ubr-cellphone.74f7d6d25809dfce52849d0dfad1db91.svg";
export { ForwardRef as ReactComponent };